export default {
  tribes: [],
  loading: false,
  generating: false,
  regenPostKey: null,
  brief: '',
  briefIsAuto: true,
  autoBrief: '',
  filter: 'all',
  error: null,
  generatedAt: null,
  generationId: null,
};
